import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "switch-group" }
const _hoisted_2 = { class: "type-button-03" }
const _hoisted_3 = { class: "switch" }
const _hoisted_4 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createVNode(_component_TranslatedText, { path: _ctx.text }, null, 8, ["path"]),
      _cache[2] || (_cache[2] = _createTextVNode("   ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          type: "checkbox",
          checked: _ctx.value,
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleValueChange && _ctx.handleValueChange(...args)))
        }, null, 40, _hoisted_4),
        _cache[1] || (_cache[1] = _createElementVNode("span", null, null, -1))
      ])
    ])
  ]))
}